import Plugin from './index';
import lifecycle from 'page-lifecycle';
import { startUploadInterval, clearUploadInterval } from '../upload';
import { getReportInfo } from '../helpers';
import Cache from '../cache';
import store from '../../../store';
import { DEFAULT_REPORT_EXCLUDE } from '../../../config/constants';

const targetCache = new Cache(500);

class ReportPlugin extends Plugin {
  name = 'report';

  init() {
    const { enableReport, include, exclude } = store.config;
    if (enableReport) {
      // 批量间隔上报
      startUploadInterval();
      lifecycle.addEventListener('statechange', (e: any) => {
        if (e.newState === 'terminated' || e.newState === 'discarded') {
          clearUploadInterval();
        }
      });

      // 点击事件监听
      window.document.addEventListener('click', (e) => {
        const target = e.target as HTMLElement;

        // 避免重复上报
        if (targetCache.has(target)) return;
        targetCache.put(target);

        // 上报
        const reportInfo = getReportInfo(e, {
          include,
          exclude: [...DEFAULT_REPORT_EXCLUDE, ...exclude || []],
        });
        if (reportInfo) {
          this.instance.reportAction(reportInfo);
        }
      });
    }
  }
}

export default ReportPlugin;
